import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './support-ticket-row-skeleton.module.scss';

export type SupportTicketRowSkeletonProps = {
  /** Number of placeholder rows. Defaults to 6. */
  count?: number;
};

/**
 * Loading placeholder for the Customer Support listing — mirrors {@link SupportTicketRow}'s
 * layout (title line, last-message preview line, trailing status chip) so the swap to real
 * rows doesn't shift the layout.
 */
export function SupportTicketRowSkeleton({ count = 6 }: SupportTicketRowSkeletonProps) {
  return (
    <div className={styles.list} aria-busy="true" aria-label="Loading tickets">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.row} data-testid="support-ticket-row-skeleton">
          <span className={styles.text}>
            <SkeletonBlock height={15} width="68%" />
            <SkeletonBlock height={13} width="90%" />
          </span>
          <SkeletonBlock height={20} width={56} radius={999} />
        </div>
      ))}
    </div>
  );
}
